import { render, staticRenderFns } from "./UserPhoneVerificationModal.vue?vue&type=template&id=245f1b20&"
import script from "./UserPhoneVerificationModal.vue?vue&type=script&lang=ts&"
export * from "./UserPhoneVerificationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports